import { BASE_URL } from '../config'

const REST_ENDPOINTS = {
  VALIDATE_TOKEN: '/register/validateTokenForRegisterPage',
  REGISTER_USER: '/register/user',
  REGISTER_ORGANIZATION: '/register/organization',
  GET_PRACTICE_NAME: '/register/practiceName',
  SUBMIT_DEMO_PAGE: '/register/demoPage',
  SEND_APP_DOWNLOAD: '/register/sendAppDownload',
  SEARCH_EMR_USERS: '/register/searchEMRUsers',
  LINK_EMR_USER: '/register/linkEMRUser',
  VERIFY_EMR_APPTS: '/register/verifyEMRAppts',
  VERIFY_EMR_NOTES: '/register/verifyEMRNotes'
}

export const validateTokenForRegisterPage = (email, token) => {
  const URL = BASE_URL + REST_ENDPOINTS.VALIDATE_TOKEN

  return fetch(URL, {

    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email,
      token
    })
  }).then(response => response.json())
}

export const registerUser = ({ firstName, lastName, suffix, practiceName, phoneNumber, specialties, timezone, email, token, password, emr, accountid, organizationId }) => {
  const URL = BASE_URL + REST_ENDPOINTS.REGISTER_USER
  return fetch(URL, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      firstName,
      lastName,
      suffix,
      practiceName,
      phoneNumber,
      specialties,
      timezone,
      email,
      token,
      password,
      emr,
      accountid,
      organizationId
    })
  })
}

export const getOrganizationById = (id) => {
  const URL = BASE_URL + REST_ENDPOINTS.GET_PRACTICE_NAME
  return fetch(URL, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ id })
  }).then(response => response.json())
}

export const registerOrganization = ({ practiceName, phoneNumber, timezone, email, emr, accountid }) => {
  const URL = BASE_URL + REST_ENDPOINTS.REGISTER_ORGANIZATION
  return fetch(URL, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      practiceName,
      phoneNumber,
      timezone,
      email,
      emr,
      accountid
    })
  })
}

export const submitDemo = (email, token) => {
  const URL = BASE_URL + REST_ENDPOINTS.SUBMIT_DEMO_PAGE
  return fetch(URL, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email,
      token
    })
  })
}

export const sendAppDownload = ({ phoneNumber, user }) => {
  const URL = BASE_URL + REST_ENDPOINTS.SEND_APP_DOWNLOAD
  return fetch(URL, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      phoneNumber,
      user
    })
  })
}

export const searchEMRUsers = ({ email, token, query, emrOrgId, sukiUserId, organizationId }) => {
  const URL = BASE_URL + REST_ENDPOINTS.SEARCH_EMR_USERS
  return fetch(URL, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email,
      token,
      query,
      emrOrgId,
      sukiUserId,
      organizationId
    })
  }).then(response => response.json())
}

export const linkEMRUser = ({ email, token, organizationId, sukiUserId, emrUserId, emrUserIdList, emrDepartmentId, timezone }) => {
  const URL = BASE_URL + REST_ENDPOINTS.LINK_EMR_USER
  return fetch(URL, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email,
      token,
      organizationId,
      sukiUserId,
      emrUserId,
      emrUserIdList,
      emrDepartmentId,
      timezone
    })
  }).then(response => response.json())
}

export const verifyEMRAppts = ({ email, token, organizationId, emrType, users, daysBeforeNow, daysAfterNow }) => {
  const URL = BASE_URL + REST_ENDPOINTS.VERIFY_EMR_APPTS
  return fetch(URL, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email,
      token,
      organizationId,
      emrType,
      users,
      daysBeforeNow,
      daysAfterNow
    })
  }).then(response => response.json())
}

export const verifyEMRNotes = ({ email, token, organizationId, emrType, emrUser }) => {
  const URL = BASE_URL + REST_ENDPOINTS.VERIFY_EMR_NOTES
  return fetch(URL, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email,
      token,
      organizationId,
      emrType,
      emrUser
    })
  }).then(response => response.json())
}
